import { combineReducers } from "redux";
import auth from './auth';
import report from './report';

export default combineReducers({
  auth,
  report
});
